import request from '@/router/axios'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) {
    return body.data
  }
  return body
}

export const getRealtimeInventoryOverview = () =>
  request({
    url: '/api/twin/store/realtime-overview',
    method: 'get'
  }).then(unwrap)

export const getInventoryTrendAnalysis = () =>
  request({
    url: '/api/twin/composite/inventory/trend-analysis',
    method: 'get'
  }).then(unwrap)

export const getDailyPlanStatus = () =>
  request({
    url: '/api/twin/composite/dashboard/wel-daily-plan-status',
    method: 'get'
  }).then(unwrap)

export const getEquipmentRealtimeStatus = () =>
  request({
    url: '/api/twin/composite/equipment/realtime-status',
    method: 'get'
  }).then(unwrap)

export const getInspectionCompletionStatus = () =>
  request({
    url: '/api/twin/composite/inspection/completion-status',
    method: 'get'
  }).then(unwrap)

export const getAccidentMonthlyTrend = (months = 12) =>
  request({
    url: '/api/produce/accident-info/statistics/monthly-trend',
    method: 'get',
    params: { months }
  }).then(unwrap)

export const getPersonnelRealtimeAbnormal = (limit = 5) =>
  request({
    url: '/api/produce/rtk-electronic-fence-event/statistics/realtime-abnormal',
    method: 'get',
    params: { limit }
  }).then(unwrap)

export const getTopCustomers = (params = {}) =>
  request({
    url: '/api/twin/composite/dashboard/top-customers',
    method: 'get',
    params
  }).then(unwrap)

export const getStoreInventoryTrend = () =>
  request({
    url: '/api/twin/store/dashboard/inventory-trend',
    method: 'get'
  }).then(unwrap)
